<template>
  <div>
    <div class="row">
      <div class="col-lg-6 col-xl-5">
        <UserInfo :userInfo="userInfo" />
      </div>
      <div class="col-lg-6 col-xl-7">
      <Setting :userInfo.sync="userInfo"/>
    </div> 
    </div>
  </div>
</template>

<script>
import request from '@/utils/request.js';
import Setting from "./Setting.vue";
import UserInfo from "./UserInfo.vue";

export default {
  name: "UserCenter",
  components: {
    UserInfo,
    Setting
  },

  data() {
    return {
      username: localStorage.getItem('soccer_username'),
      userInfo: {

      }
    };
  },

  mounted() {
    this.getUserInfo();
  },

  methods: {
    async getUserInfo() {
      var post_url = 'football/admin/william/interfaceAction!getPersonInfo.action'
      let opts = {
        type: 1, //1为数据接口；2为静态资源请求
        url: post_url,
        method: 'get'
      };
      await request.httpRequest(opts).then(response => {
        if (response.status == 200) {
          if (response == null) {
            // ElMessage({
            //   message: '网络错误',
            //   type: 'warning',
            // })
            return;
          }
          if (response.data.status == 0) {
            // ElMessage({
            //   message: response.data.message,
            //   type: 'warning',
            // })
            return;
          }
          this.userInfo = response.data.Person;
          if (this.userInfo.registerType == 'week') {
            this.userInfo.registerType = '周卡';
          }
          if (this.userInfo.registerType == 'year') {
            this.userInfo.registerType = '年卡';
          }
          if (this.userInfo.registerType == 'month') {
            this.userInfo.registerType = '月卡';
          }
          if (this.userInfo.registerType == 'quarter') {
            this.userInfo.registerType = '季卡';
          }
        }
      });


    },
  }
};
</script>